import React from 'react'
import {Link} from 'react-router-dom'
import './Component.css'
import {project_categories, project_categories_links} from '../Catagories'
import { HashLink } from 'react-router-hash-link';
import pdf from "../pdf/CV2026.pdf"
import design from "../pdf/design_portfolio_vivian.pdf"


class List extends React.Component{
    render(){
        console.log(window.location.pathname[1] == 'h')
        return(
            <div>
                <HashLink smooth to={window.location.pathname[1] == 'h'? "#me":"/hi"} >
                    <h3 className="list-link">About Me</h3>
                </HashLink> 
                
                <HashLink smooth to="/hi#projects">
                    <h3 className="list-link">Research</h3>
                </HashLink>

                <a
                href={design}
                target="_blank"
                rel="noopener noreferrer"
                >
                <h3 className="list-link">Design</h3>
                </a>
                
                <a
                href={pdf}
                target="_blank"
                rel="noopener noreferrer"
                >
                <h3 className="list-link">CV</h3>
                </a>
                
            </div>
        )
    }
}

export default List